const SESSION_TIMEOUT = 30 * 60 * 1000

interface Session { id: string; lastActive: number }

export function activitySession(storage: Storage, userId: number, now = Date.now()): string {
  const key = `easel-activity-session-${userId}`
  let session: Session | null = null
  try {
    const stored = JSON.parse(storage.getItem(key) || 'null') as Session | null
    if (stored && typeof stored.id === 'string' && Number.isFinite(stored.lastActive) &&
      now >= stored.lastActive && now - stored.lastActive < SESSION_TIMEOUT) session = stored
  } catch { /* Corrupt storage starts a new session. */ }
  if (!session) session = { id: crypto.randomUUID(), lastActive: now }
  session.lastActive = now
  storage.setItem(key, JSON.stringify(session))
  return session.id
}

const routes: [RegExp, string][] = [
  [/^\/app\/(dashboard)?$/, 'home'],
  [/^\/app\/artworks(?:\/|$)/, 'artworks'],
  [/^\/app\/upload$/, 'upload'],
  [/^\/app\/easel\/collections(?:\/|$)/, 'collections'],
  [/^\/app\/easel\/biography$/, 'biography'],
  [/^\/app\/easel\/journal(?:\/|$)/, 'journal'],
  [/^\/app\/easel\/shop$/, 'shop'],
  [/^\/app\/easel\/commissions(?:\/|$)/, 'commissions'],
  [/^\/app\/easel\/contact$/, 'contact'],
  [/^\/app\/easel\/profile$/, 'link_in_bio'],
  [/^\/app\/easel\/short-links$/, 'short_links'],
  [/^\/app\/easel\/hero$/, 'hero_studio'],
  [/^\/app\/easel\/settings$/, 'settings'],
  [/^\/app\/easel\/site-content$/, 'site_content'],
  [/^\/app\/easel$/, 'portfolio'],
  [/^\/app\/analytics$/, 'insights'],
  [/^\/app\/social\/creator$/, 'social_creator'],
  [/^\/app\/social\/calendar$/, 'social_calendar'],
  [/^\/app\/marketing\/email$/, 'email_marketing'],
  [/^\/app\/marketing\/drops$/, 'drops'],
  [/^\/app\/sales$/, 'sales'],
  [/^\/app\/(account|profile)$/, 'account'],
]

export function activityFeature(path: string): string | null {
  return routes.find(([pattern]) => pattern.test(path))?.[1] || (path === '/app' ? 'home' : null)
}
